import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = 'Карат-сервис', 
  description = 'Карат-сервис. Строительный интернет-магазин. Строительные материалы в Жодино. Единственный официальный представитель торговых марок ПТ ООО «Тайфун» и СОО «Condor» в регионе.',
  keywords = 'карат сервис жодино строительные материалы карат-сервис жодинский магазин купить штукатурку тайфун мастер condor ilmax смеси штукатурка пена герметик краску краска фасадная гипсокартон',
  image = '/images/logo.svg',
  url = 'https://store-be1e1.web.app/',
  type = 'website'
}) => {
  const fullTitle = title === 'Карат-сервис' ? title : `${title} | Карат-сервис`;
  const fullUrl = url.startsWith('http') ? url : `https://store-be1e1.web.app${url}`;
  const fullImage = image.startsWith('http') ? image : `https://store-be1e1.web.app${image}`;

  return (
    <Helmet>
      {/* Основные meta теги */}
      <html lang="ru" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph теги для социальных сетей */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Карат-сервис" />
      <meta property="og:locale" content="ru_RU" />
      
      {/* Twitter Card теги */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Дополнительные SEO теги */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Карат-сервис" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Структурированные данные для организации */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Карат-сервис",
          "description": "Строительный интернет-магазин в Жодино. Строительные материалы оптом и в розницу.",
          "url": "https://store-be1e1.web.app/",
          "telephone": "+375-29-XXX-XX-XX",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Жодино",
            "addressCountry": "BY"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 54.083866,
            "longitude": 28.314445
          },
          "openingHours": "Mo-Fr 09:00-18:00",
          "priceRange": "$$",
          "image": fullImage,
          "sameAs": [
            // Добавьте ссылки на социальные сети, если есть
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
